import { UIContextQuery } from "common/api/UIContext";
import { update, EndpointCall } from "components/http/endpoint";
import { create as createRequest } from "components/http/rest/jsonRequest";
import { ApiUriPrefix } from "../apiUriPrefix";

const ApiUri = ApiUriPrefix + "uicontext";

function query(query: UIContextQuery): EndpointCall {
    const request = createRequest(query);
    return update(ApiUri, request);
}

export {
    query
}
